import React from 'react';

export const AnimatedBorder: React.FC = () => (
  <svg className='tour-animated-border' xmlns='http://www.w3.org/2000/svg'>
    <rect x='1' y='1' width='calc(100% - 2px)' height='calc(100% - 2px)' rx='24' ry='24' />
  </svg>
);
